<template>
	<v-dialog v-model="child_dialog" max-width="600px">
			<app-card>
				<app-section-loader :status="form_loader"></app-section-loader>
				<h4>Phiếu ghi nhận điều chỉnh công nợ/ lợi nhuận</h4>
				<v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu_month"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <v-text-field
                                        slot="activator"
                                        v-model="form.month"
                                        label="Chọn tháng"
                                        :disabled="isEdit"
                                        prepend-icon="event"
                                        readonly
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    <v-date-picker
                                        locale="vi-VI"
                                        type="month"
                                        v-model="form.month"
                                        @input="menu_month = false"
                                        v-if="!isEdit"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                    label="Số tiền"
                                    v-model="form.amount"
                                    prepend-icon="money"
                                    required
                                    :rules="[rules.required]"
                                    @input="formatMoney"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-textarea
                                    label="Ghi chú"
                                    v-model="form.note"
                                    prepend-icon="note"
                                    rows="3"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="cancelInput">Hủy</v-btn>
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="submit"
                            color="primary"
                        >{{ isEdit ? 'Cập nhật' : 'Tạo phiếu' }}</v-btn>
                    </v-card-actions>
                </v-form>
			</app-card>
	</v-dialog>
</template>

<script>
import api from "Api";

export default {
	name: "dialog-tao-phieu-dieu-chinh-cong-no-loi-nhuan",
	props: {
		dialog: Boolean,
        editingItem: Object
	},
	data() {
		return {
			child_dialog: false,
			form_loader: false,
			menu_month: false,
			rules: {
				required: value => !!value || "Vui lòng điền thông tin này."
			},
			form: {
                month: "",
                amount: "",
                note: ""
            },
			loading: {
                submit: false
            },
		};
	},
    computed: {
        isEdit() {
            return !!this.editingItem;
        }
    },
	watch: {
		dialog(nv){
			this.child_dialog = nv;
            if (nv) {
                if (this.editingItem) {
                    // Edit mode
                    const [m, y] = this.editingItem.month.split('/');
                    // v-date-picker expects YYYY-MM
                    this.form.month = `${y}-${m.padStart(2, '0')}`;
                    this.form.amount = this.editingItem.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    this.form.note = this.editingItem.note;
                } else {
                    // Create mode
                    this.form = {
                        month: new Date().toISOString().substr(0, 7),
                        amount: "",
                        note: ""
                    };
                }
            }
		},
		child_dialog(nv) {
			this.$emit("changeDialogState", nv);
		},
	},
	methods: {
		formatMoney() {
			let amount = this.form.amount;
			if (amount) {
                amount = amount.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.form.amount = amount;
            }
		},
		cancelInput() {
			this.child_dialog = false;
		},
		submit: async function() {
			if (!this.$refs.form.validate()) {
				swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
                return;
			}

			this.loading.submit = true;

            const [year, month] = this.form.month.split('-');
            
			const postData = {
                month: month,
                year: year,
				amount: Number(this.form.amount.replace(/,/g, "")),
                note: this.form.note
			};

            if (this.isEdit) {
                postData._id = this.editingItem._id;
            }

			try {
                const data = await api.createOrEditProfitDebtAdjustment(postData);
                this.loading.submit = false;

                if (data.status === 200) {
                    this.child_dialog = false;
                    this.$emit("refresh");
                    swal.fire("Thành công", data.data.message, "success");
                } else {
                    swal.fire("Lỗi", data.message || "Có lỗi xảy ra", "error");
                }
            } catch (e) {
                this.loading.submit = false;
                swal.fire("Lỗi", e.message || "Có lỗi xảy ra", "error");
            }
		}
	}
};
</script>
